import standardNew from '@config/standard.js';
import standardLegacy from '@config/standardLegacy.js';

/**
 * Returns the correct Axios instance based on the feature flag for the new auth flow.
 */
export default function getStandardInstance() {
    return process.env.VUE_APP_NEW_AUTH_FLOW === 'true' ? standardNew : standardLegacy;
}